export default __webpack_public_path__ + "static/about_tolerance-0e43474dd144ba8ca7b230b86fd01c12.webp";